import { GlassCard } from '@shared/ui/glass-card'
import { motion } from 'motion/react'

const FEATURES = [
  {
    image: '/result_meu_assets/1_my.png',
    title: '사주 원국 분석',
    description: '사주팔자 네 기둥과 일주의 성향을 깊이 있게 풀어드려요.',
  },
  {
    image: '/result_meu_assets/2_five.png',
    title: '오행 밸런스 차트',
    description: '나의 오행 분포를 인터랙티브 차트로 한눈에 확인해요.',
  },
  {
    image: '/result_meu_assets/4_strategy.png',
    title: '재능과 전략',
    description: '타고난 강점과 그 활용법을 사주 관점에서 분석해요.',
  },
  {
    image: '/result_meu_assets/5_money.png',
    title: '재물운',
    description: '재물의 흐름과 기회를 오행 밸런스로 읽어드려요.',
  },
  {
    image: '/result_meu_assets/6_love.png',
    title: '연애·인연운',
    description: '사주에 담긴 연애 성향과 인연의 특징을 알려드려요.',
  },
  {
    image: '/result_meu_assets/7_calendar.png',
    title: '12개월 월별 운세',
    description: '올해 매달 찾아올 기회와 주의할 흐름을 알려드려요.',
  },
  {
    image: '/result_meu_assets/8_bubble.png',
    title: '고민 분석',
    description: '입력한 고민을 사주 관점에서 해석해드려요.',
  },
  {
    image: '/result_meu_assets/3_total_saju.png',
    title: '종합 운세',
    description: '당신의 사주를 하나의 이야기로 종합해서 풀어드려요.',
  },
] as const

export function ProductIntroSection() {
  return (
    <section className="px-page-x py-12">
      <motion.div
        className="mb-8"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-40px' }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="typo-heading font-bold text-foreground">정통 사주 풀이</h2>
        <p className="mt-2 typo-label text-muted-foreground">
          명리학 기반으로 타고난 기질과 인생의 흐름을 분석해요.
        </p>
      </motion.div>

      <GlassCard className="px-4 py-2" style={{ border: 'none' }}>
        <div className="divide-y divide-gray-200">
          {FEATURES.map((feat, i) => (
            <motion.div
              key={feat.title}
              className="flex w-full items-center gap-4 py-6"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-20px' }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
            >
              <img
                src={feat.image}
                alt=""
                aria-hidden="true"
                draggable={false}
                className="size-11 shrink-0 object-contain"
              />
              <div className="min-w-0 flex-1">
                <h3 className="typo-body font-bold text-foreground">{feat.title}</h3>
                <p className="mt-1 typo-label text-muted-foreground">{feat.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </GlassCard>

    </section>
  )
}
